import InstagramTaggedProductService from "./InstagramTaggedProductService";

export default InstagramTaggedProductService;
